import { KYMW1307Component } from './kymw1307.component';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * 予算・計画・実績表画面の値を管理するクラス
 *
 * @export KYMW1307Model
 * @class KYMW1307Model
 */
export class KYMW1307Model {

  kymw1307Component: KYMW1307Component;

  public budgetAmount: string = null;                                           // 予算・金額（千円）
  public budgetGP: string = null;                                               // 予算・粗利（千円）
  public planAmount: string = null;                                             // 計画・金額 総額（千円）
  public planAmountRatio: string = null;                                        // 計画・金額 予算比
  public planGP: string = null;                                                 // 計画・粗利 総額（千円）
  public planGPRatio: string = null;                                            // 計画・粗利 予算比
  public planThisGP: string = null;                                             // 計画・今年 ＧＰ（千円）
  public planThisGPR: string = null;                                            // 計画・今年 ＧＰＲ
  public planThisAveragePrice: string = null;                                   // 計画・今年 点単価
  public planRatioGP: string = null;                                            // 計画・前年比 ＧＰ（千円）
  public planRatioGPR: string = null;                                           // 計画・前年比 ＧＰＲ
  public planRatioAveragePrice: string = null;                                  // 計画・前年比 点単価
  public resultsAmount: string = null;                                          // 実績・金額 総額（千円）
  public resultsAmountRatio: string = null;                                     // 実績・金額 予算比
  public resultsGP: string = null;                                              // 実績・粗利 総額（千円）
  public resultsGPRatio: string = null;                                         // 実績・粗利 予算比
  public resultsThisGP: string = null;                                          // 実績・今年 ＧＰ（千円）
  public resultsThisGPR: string = null;                                         // 実績・今年 ＧＰＲ
  public resultsThisAveragePrice: string = null;                                // 実績・今年 点単価
  public resultsRatioGP: string = null;                                         // 実績・前年比 ＧＰ（千円）
  public resultsRatioGPR: string = null;                                        // 実績・前年比 ＧＰＲ
  public resultsRatioAveragePrice: string = null;                               // 実績・前年比 点単価

  /**
   * サーバ取得データ反映
   *
   * @param data APIレスポンス
   */
  public updateKYMW1307(data: any): void {
    this.budgetAmount = data.BudgetAmount;
    this.budgetGP = data.BudgetGP;
    this.planAmount = data.PlanAmount;
    this.planAmountRatio = data.PlanAmountRatio;
    this.planGP = data.PlanGP;
    this.planGPRatio = data.PlanGPRatio;
    this.planThisGP = data.PlanThisGP;
    this.planRatioGP = data.PlanRatioGP;
    this.planThisGPR = data.PlanThisGPR;
    this.planRatioGPR = data.PlanRatioGPR;
    this.planThisAveragePrice = data.PlanThisAveragePrice;
    this.planRatioAveragePrice = data.PlanRatioAveragePrice;
    this.resultsAmount = data.ResultsAmount;
    this.resultsAmountRatio = data.ResultsAmountRatio;
    this.resultsGP = data.ResultsGP;
    this.resultsGPRatio = data.ResultsGPRatio;
    this.resultsThisGP = data.ResultsThisGP;
    this.resultsRatioGP = data.ResultsRatioGP;
    this.resultsThisGPR = data.ResultsThisGPR;
    this.resultsRatioGPR = data.ResultsRatioGPR;
    this.resultsThisAveragePrice = data.ResultsThisAveragePrice;
    this.resultsRatioAveragePrice = data.ResultsRatioAveragePrice;
  }
}
